import React, { Component } from 'react'
import isEqual from 'fast-deep-equal'
import themeVars from 'ui_theme/site/globals/site.variables'
import SpacedItems from 'shared/components/ui/SpacedItems'

import AgentsChip from './AgentsChip'

export default class AgentCollision extends Component {
  shouldComponentUpdate(nextProps) {
    return !isEqual(this.props, nextProps)
  }

  render() {
    const {
      viewingAgents,
      replyingAgents,
      typingAgents,
      noteLeavingAgents,
    } = this.props
    if (
      viewingAgents.length === 0 &&
      replyingAgents.length === 0 &&
      typingAgents.length === 0 &&
      noteLeavingAgents.length === 0
    ) {
      return null
    }
    return (
      <SpacedItems.Container
        direction="horizontal"
        gap="large"
        css={`
          padding: 0 ${themeVars.big} ${themeVars.large};
          overflow: hidden;
          position: absolute;
          top: -48px;
        `}
      >
        {viewingAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={viewingAgents} type="viewing" />
          </SpacedItems.Item>
        )}
        {replyingAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={replyingAgents} type="replying" />
          </SpacedItems.Item>
        )}
        {typingAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={typingAgents} type="typing" />
          </SpacedItems.Item>
        )}
        {noteLeavingAgents.length > 0 && (
          <SpacedItems.Item>
            <AgentsChip users={noteLeavingAgents} type="noting" />
          </SpacedItems.Item>
        )}
      </SpacedItems.Container>
    )
  }
}
